import { render, staticRenderFns } from "./PrimaryCards.vue?vue&type=template&id=450d8ba2&scoped=true&"
import script from "./PrimaryCards.vue?vue&type=script&lang=js&"
export * from "./PrimaryCards.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryCards.vue?vue&type=style&index=0&id=450d8ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d8ba2",
  null
  
)

export default component.exports